"use client"

import { useState, useEffect, useRef } from "react"
import "./QASolutions.css"
import BlueSectionDivider from "./BlueSectionDivider"
import {Link} from 'react-router-dom'

const numbers = [
  { num: "+20", text: "INDUSTRY SECTORS" },
  { num: "78", text: "CUSTOMER NPS SCORE" },
  { num: "99%", text: "RECOMMENDATION RATE" },
  { num: "+300", text: "PROJECTS DELIVERED" },
]

const cards = [
  {
    id: 1,
    img: "/icons/mobile.png", // Replace with actual icons
    title: "MOBILE APPS",
  },
  {
    id: 2,
    img: "/icons/saas.png", // Replace with actual icons
    title: "SOFTWARE AS A SERVICE(SAAS)",
  },
  {
    id: 3,
    img: "/icons/api.webp", // Replace with actual icons
    title: "API DEVELOPMENT",
  },
  {
    id: 4,
    img: "/icons/custom.webp", // Replace with actual icons
    title: "CUSTOM SOFTWARE",
  },
  {
    id: 5,
    img: "/icons/cloud.webp", // Replace with actual icons
    title: "CLOUD-BASED APP DEVELOPMENT",
  },
  {
    id: 6,
    img: "/icons/enterprise.webp", // Replace with actual icons
    title: "ENTERPRISE SOFTWARE",
  },
]

const SolutionsSection = (props) => {
  const [active, setActive] = useState("solution") // State for this navbar's active link
  const cardRefs = useRef([])
  const headingRef = useRef(null)
  const paraRef = useRef(null)
  const descRef = useRef(null)

  // Define section IDs for the solutions-navbar highlighting based on actual section IDs in this component
  // Currently, only the main section has an ID. If you add more sections with IDs, include them here.
  const sectionsToHighlight = [
   "solution",
    "process", // Section exists, but no direct link in navbar for 'components'
    "benefits",
    "team",
    "tech-stack",
    "faq",
    "contact-us",// This is the ID of the main section
    // Add other section IDs here if they exist within SolutionsSection.jsx
    // e.g., "process", "benefits", etc.
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.2 },
    )
    ;[...cardRefs.current, headingRef.current, paraRef.current, descRef.current].forEach((ref) => {
      if (ref) observer.observe(ref)
    })
    return () => observer.disconnect()
  }, [])

  // Effect for the solutions-navbar highlighting
  useEffect(() => {
    const handleScroll = () => {
      // Approximate height of this solutions-navbar
      // You might need to adjust this value based on the actual height of your navbar
      const solutionsNavbarHeight = 60
      const scrollPosition = window.scrollY + solutionsNavbarHeight + 20 // Add a small buffer

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i])
        if (section && section.offsetTop <= scrollPosition) {
          // The section ID "solution" directly matches the navbar link "solution"
          setActive(sectionsToHighlight[i])
          break
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll() // Call once to set initial state

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleClick = (id) => {
    setActive(id) // Set active state to the clicked navbar item text
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <>
     <div className="solutions-navbar">
      <div className="container">
        <ul>
          {["solution", "process", "benefits", "team", "tech-stack", "faq", "contact-us"].map((item) => (
            <li key={item}>
              <a onClick={() => handleClick(item)} className={active === item ? "active" : ""}>
                {item.toUpperCase().replace("_", " ")}
              </a>
            </li>
          ))}
        </ul>
        </div>
      </div>
    <section className="solutions-section" id="solution">
      <div className="container">
     
      <div className="content">
        <div className="numbers-row">
          {numbers.map((n) => (
            <div key={n.num} className="number-block">
              <div className="big-num">{n.num}</div>
              <div className="num-text">{n.text}</div>
            </div>
          ))}
        </div>
        <BlueSectionDivider />
        <div className="solutions-header2122">
          <h2 ref={headingRef} className="fade-in-left">
            OUR <span className="blue"><br/>SOLUTIONS</span>
          </h2>
          <p className="solutions-intro fade-in-right" ref={paraRef}>
            {props.para1}
          </p>
        </div>
        <p className="solutions-description fade-in-left" ref={descRef}>
          {props.para2}
        </p>
        <div className="solutions-cards">
          {cards.map((card, idx) => (
            <div key={card.id} className="solution-card fade-up" ref={(el) => (cardRefs.current[idx] = el)}>
              <img src={card.img || "/placeholder.svg"} alt="icon" className="card-icon" />
              <h3>{card.title}</h3>
            </div>
          ))}
        </div>
      </div>
      <div className="down-btn">
        <Link to="/industries">
        <button>SEE INDUSTRIES WE WORK IN</button>
        </Link>
      </div>
      {/* Placeholder sections for other navbar links if they were to exist */}
      {/* <section id="process" style={{ height: "500px", background: "#e0e0e0", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "50px" }}><h2>PROCESS Section</h2></section> */}
      {/* <section id="benefits" style={{ height: "500px", background: "#d0d0d0", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "50px" }}><h2>BENEFITS Section</h2></section> */}
      {/* ... and so on for team, tech-stack, faq, contact-us */}
      </div>
    </section>
    </>
  )
}

export default SolutionsSection
